var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service from '@ember/service';
import { getOwner } from '@ember/application';
import { alias } from '@ember/object/computed';
import environment from '../environment';
let Environment = (_dec = alias('_instance.isMobile'), _dec2 = alias('_instance.isAndroid'), _dec3 = alias('_instance.isIOS'), _dec4 = alias('_instance.isDevelopment'), _dec5 = alias('_instance.isTesting'), _dec6 = alias('_instance.isStaging'), _dec7 = alias('_instance.isSandbox'), _dec8 = alias('_instance.isProduction'), _dec9 = alias('_instance.isHeadless'), _dec10 = alias('_instance.name'), _class = class Environment extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_instance", void 0);
    _initializerDefineProperty(this, "isMobile", _descriptor, this);
    _initializerDefineProperty(this, "isAndroid", _descriptor2, this);
    _initializerDefineProperty(this, "isIOS", _descriptor3, this);
    _initializerDefineProperty(this, "isDevelopment", _descriptor4, this);
    _initializerDefineProperty(this, "isTesting", _descriptor5, this);
    _initializerDefineProperty(this, "isStaging", _descriptor6, this);
    _initializerDefineProperty(this, "isSandbox", _descriptor7, this);
    _initializerDefineProperty(this, "isProduction", _descriptor8, this);
    _initializerDefineProperty(this, "isHeadless", _descriptor9, this);
    _initializerDefineProperty(this, "name", _descriptor10, this);
  }
  init() {
    super.init();
    this.set('_instance', getOwner(this).lookup('environment:current') || environment());
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isMobile", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isAndroid", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isIOS", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isDevelopment", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isTesting", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isStaging", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isSandbox", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isProduction", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isHeadless", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Environment as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.